module.exports = __webpack_public_path__ + "media/src/images/icons/link-chevron-back-3fe311d69fb488306e5d5eae994c0cf5.svg";